import {
    TutorialIntroModalCloseButtonStyled,
    TutorialIntroModalContentStyled,
    TutorialIntroModalInnerWrapperStyled,
    TutorialIntroModalLeftContainer,
    TutorialIntroModalWatchLaterFooterStyled,
} from './styled/TutorialIntroModalStyled';
import { Button } from 'react-bootstrap';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsFirstShowIntroSelector } from '../../tutorialsSelectors';
import BinIcon from '../../../../components/icon/Icon';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { setIsFirstShowIntroAction, showWatchMoreVideosLaterTooltipAction } from '../../tutorialsReducer';
import useTutorialIntroModalGTMEvents from './hooks/useTutorialIntroModalGTMEvents';
import useTutorialIntroModalContentEvents from './hooks/useTutorialIntroModalContentEvents';
import TutorialIntroModalVideoPlayButton from './TutorialIntroModalVideoPlayButton/TutorialIntroModalVideoPlayButton';
import { closeModalAction } from '../../../../app/appActions';

function TutorialIntroModal() {
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();
    const isFirstShowIntro = useSelector(getIsFirstShowIntroSelector);
    const { handleSendIsPlayedIntroVideoGTMEvent } = useTutorialIntroModalGTMEvents(isFirstShowIntro);
    const tutorialLink = useMemo(() => getLangPath('video_tutorial.link', {}, { emptyDefault: true }), [getLangPath]);

    const {
        isContentClicked,
        isContentHovered,
        handleContentClick,
        handleContentMouseEnter,
        handleContentMouseLeave,
    } = useTutorialIntroModalContentEvents({
        onContentClick: () => handleSendIsPlayedIntroVideoGTMEvent(true),
    });

    const handleCloseModal = useCallback(() => dispatch(closeModalAction()), [dispatch]);

    useEffect(() => {
        if (!tutorialLink) {
            handleCloseModal();
            return;
        }
        return () => {
            if (isFirstShowIntro) {
                dispatch(showWatchMoreVideosLaterTooltipAction(true));
                dispatch(setIsFirstShowIntroAction(false));
            }
        };
    }, [dispatch, handleCloseModal, isFirstShowIntro, tutorialLink]);

    return (
        <div className='position-relative'>
            <TutorialIntroModalContentStyled
                onClick={handleContentClick}
                onMouseEnter={handleContentMouseEnter}
                onMouseLeave={handleContentMouseLeave}
            >
                {!isContentClicked ? (
                    <>
                        <TutorialIntroModalInnerWrapperStyled>
                            <TutorialIntroModalLeftContainer>
                                <TutorialIntroModalVideoPlayButton hover={isContentHovered}/>
                            </TutorialIntroModalLeftContainer>
                            <div>
                                <h1>{getLangPath('video_tutorial.title')}</h1>
                                <p>{getLangPath('video_tutorial.intro.description')}</p>
                            </div>
                        </TutorialIntroModalInnerWrapperStyled>
                    </>
                ) : (
                    <iframe
                        width='100%'
                        height='100%'
                        src={`${getLangPath('video_tutorial.link')}?autoplay=1`}
                        title='Intro Modal'
                        frameBorder='0'
                        allow='autoplay'
                        allowFullScreen
                    />
                )}
            </TutorialIntroModalContentStyled>
            {isFirstShowIntro && (
                <TutorialIntroModalWatchLaterFooterStyled>
                    <p className={'mb-0'}>{getLangPath('video_tutorial.watch_later.description')}</p>
                    <Button
                        onClick={handleCloseModal}
                        variant={'secondary'}
                    >
                        {getLangPath('video_tutorial.watch_later.button')}
                    </Button>
                </TutorialIntroModalWatchLaterFooterStyled>
            )}
            <TutorialIntroModalCloseButtonStyled onClick={handleCloseModal}>
                <BinIcon name='IcXMarkThin' size={40}/>
            </TutorialIntroModalCloseButtonStyled>
        </div>
    );
}

export default TutorialIntroModal;
